import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

// Premium progress bar using design tokens only.
export function ProgressBar({ value = 0, className, showLabel = false, tone = "brand" }) {
  const pct = Math.max(0, Math.min(100, value));
  const bar = tone === "success" ? "bg-success" : "bg-brand";
  return (
    <div className={cn("space-y-1.5", className)}>
      {showLabel && (
        <div className="flex items-center justify-between text-xs tabular-nums text-muted-foreground">
          <span>{pct}%</span>
        </div>
      )}
      <div className="h-2 w-full overflow-hidden rounded-full bg-border" data-testid="progress-track">
        <motion.div
          className={cn("h-full rounded-full", bar)}
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
    </div>
  );
}
